"use client";
import { atom } from "jotai";
import { ChatSessionsModel } from "@/app/lib/models/ChatSessionsModel";
import { UserDetailsModel } from "@/app/lib/models/UserDetailsModel";
import { MemberDetailsModel } from "@/app/lib/models/MemberDetailsModel";
import { RegistrationFormDataModel } from "@/app/lib/models/RegistrationFormDataModel";
import { PaymentDetailsModel } from "@/app/lib/models/PaymentDetailsModel";
import {
  EnrichedEventModel,
  EventDetailsModel,
} from "@/app/lib/models/EventDetailsModel";
import type { PersonalisationModel } from "@/app/lib/models/PersonalisationModel";

export const selectedMemberIdAtom = atom("");
/** Persists trainee filter selection across members/events pages for admin & center head. */
export const selectedTraineeFilterAtom = atom("");
export const registrationFormDataAtom = atom<RegistrationFormDataModel>(
  {} as RegistrationFormDataModel,
);
export const memberListWithDetailsAtom = atom<Map<string, MemberDetailsModel>>(
  new Map<string, MemberDetailsModel>(),
);
export const guardianListWithDetailsAtom = atom<Map<string, UserDetailsModel>>(
  new Map<string, UserDetailsModel>(),
);
export const centerHeadListWithDetailsAtom = atom<
  Map<string, UserDetailsModel>
>(new Map<string, UserDetailsModel>());
export const traineesListWithDetailsAtom = atom<Map<string, UserDetailsModel>>(
  new Map<string, UserDetailsModel>(),
);
/** True after dashboard layout trainee fetch finishes (including empty results). */
export const traineesListFetchSettledAtom = atom(false);
/** True after dashboard layout guardian fetch finishes (including empty results). */
export const guardiansListFetchSettledAtom = atom(false);
/** True after dashboard layout members fetch finishes (including empty results). */
export const membersListFetchSettledAtom = atom(false);
export const chatSessionsListDataAtom = atom<Map<string, ChatSessionsModel>>(
  new Map<string, ChatSessionsModel>(),
);
/** Skip full-page loader when swapping to a new session in-place (New topic). */
export const intentionalSessionRolloverAtom = atom<boolean>(false);
// export const imagesToUploadAtom = atom<Map<string, File>>(new Map<string, File>());
export const showLayoutOnSmallScreenAtom = atom<boolean>(false);
export const loggedInUserDetailsAtom = atom<UserDetailsModel>();
export const registrationMemberPhotoAtom = atom<Blob | undefined>(undefined);
export const registrationChildPhotoAtom = atom<Blob | undefined>(undefined);
export const guardianPhotoAtom = atom<Blob | string | undefined>(undefined);
export const paymentsAtom = atom<PaymentDetailsModel[]>(
  [] as PaymentDetailsModel[],
);
export const isRedirectToSubscriptionPageAtom = atom<boolean>(false);
export const isRedirectToQuizPageAtom = atom<boolean>(false);
export const EventFormDataAtom = atom<EventDetailsModel>(
  {} as EventDetailsModel,
);

/** All events for all members - populated by fetchAllEvents, used by viewEvents/personalisation */
export const allEventsListAtom = atom<EnrichedEventModel[]>([]);

/** Personalisation data per member - populated by fetchPersonalisation, used by personalisation page */
export const personalisationByMemberIdAtom = atom<
  Map<string, PersonalisationModel>
>(new Map());

/** Dashboard trainee/guardian counts from /count APIs — refreshed after user creation. */
export const dashboardUserCountsAtom = atom<{
  traineesCount: number;
  guardiansCount: number;
}>({
  traineesCount: 0,
  guardiansCount: 0,
});
